import React from "react";
import Layout from "../../layout/builders/Layout";

const JobProjectManagement = () => {
  return (
    <Layout>
      <div className="min-h-screen bg-gray-50 p-4">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-lg shadow-md p-8 text-center">
            <div className="mb-6">
              <h1 className="text-3xl font-bold text-gray-800 mb-2">
                Job Project Management
              </h1>
              <p className="text-gray-600">
                Manage your job projects efficiently and effectively
              </p>
            </div>
            
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-6">
              <div className="flex items-center justify-center mb-4">
                <div className="bg-blue-500 text-white rounded-full p-3">
                  <svg
                    className="w-8 h-8"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
              </div>
              <h2 className="text-2xl font-semibold text-blue-800 mb-2">
                Coming Soon
              </h2>
              <p className="text-blue-600">
                We're working hard to bring you an amazing job project management experience. 
                Stay tuned for updates!
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-left">
              <div className="bg-gray-50 rounded-lg p-4">
                <h3 className="font-semibold text-gray-800 mb-2">Project Tracking</h3>
                <p className="text-gray-600 text-sm">
                  Track the progress of your job projects from start to finish
                </p>
              </div>
              <div className="bg-gray-50 rounded-lg p-4">
                <h3 className="font-semibold text-gray-800 mb-2">Team Collaboration</h3>
                <p className="text-gray-600 text-sm">
                  Collaborate with your team members on project tasks
                </p>
              </div>
              <div className="bg-gray-50 rounded-lg p-4">
                <h3 className="font-semibold text-gray-800 mb-2">Resource Management</h3>
                <p className="text-gray-600 text-sm">
                  Manage project resources and allocation efficiently
                </p>
              </div>
              <div className="bg-gray-50 rounded-lg p-4">
                <h3 className="font-semibold text-gray-800 mb-2">Timeline Planning</h3>
                <p className="text-gray-600 text-sm">
                  Plan and schedule project timelines with precision
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default JobProjectManagement;


